import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=d662d764&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=d662d764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d662d764",
  null
  
)

export default component.exports